(function (){
  'use strict';

  angular.module('tfc.retailer.StandardReports')
      .directive('tfcStandardReportsFilter', Filter)
      .factory('FilterModal', FilterModal)
      .controller('StandardReportsFilterCtrl', StandardReportsFilterCtrl);


  // @ngInject
  function FilterModal($uibModal, $document, DateUtil, MIN_DATE, AreaLineChartAxisHandle) {

    return {
      showModal : showModal
    };

    function showModal() {
      var parentElem = angular.element($document[0].querySelector('.master-container'));
      var modalInstance = $uibModal.open({
        size: 'sm',
        templateUrl: 'StandardReports/Filters/FilterModal.tmpl.html',
        windowTopClass: 'model-right-top-window',
        appendTo: parentElem,
        controller: function ($scope, Filters, $state, AnalyticsHelper) {
          var vm = $scope;

          var selectedFn = function(filter) { return _.find(filter, {isSelected: true}) };

          var updateFilterFn = function(arr, selectedFilter) {
            _.map(arr, function (obj) {
              obj.isSelected = obj.name === selectedFilter.name;
            })
          };

          vm.toggleDetailLevel = function(selectedDetailLevel) {
            return updateFilterFn(vm.filter.detailLevel, selectedDetailLevel);
          };

          vm.toggleRegions = function(selectedObj){
            selectedObj.indeterminate = false;
            return _.forEach(childElements(selectedObj), function(o){
              o.isSelected = selectedObj.isSelected;
              o.indeterminate = false;
            });
          };

          vm.toggleParentRegion =  function(parent, self){
            vm.toggleRegions(self);
            setParentIsSelected(parent);
          };

          vm.cancel = function () {
            modalInstance.close();
          };

          vm.setDimension = function () {
            Filters.setFilter(vm.filter);
            goAndUpdateState();
            vm.cancel();
          };

          vm.reset = function () {
            Filters.resetFilter();
            goAndUpdateState();
            vm.cancel();
          };

          var goAndUpdateState = function(){
            var filterParams = Filters.getFilterParams();
            var addressable = Filters.getFilter().addressable;
            var queryParams = _.merge(filterParams.queryParams, filterParams.pathParams, {addressable: addressable});
            AnalyticsHelper.sendAnalyticsFilterChangeEvent(queryParams);
            $state.go('.', queryParams);
          };

          onInit();


          function capitalizeDimensionNames(arr){
            arr.forEach(function(obj){obj.name = _.capitalize(obj.name);})
          }

          function onInit() {
            vm.filter = Filters.getFilter();
            vm.minStartDate = DateUtil.shortMonthDate(MIN_DATE);
            vm.maxDate = DateUtil.shortMonthDate(vm.filter.maxAllowedDate);
            vm.filter.dateRange.startDate = DateUtil.shortMonthDate(vm.filter.dateRange.startDate);
            vm.filter.dateRange.endDate = DateUtil.shortMonthDate(vm.filter.dateRange.endDate);
            capitalizeDimensionNames(vm.filter.detailLevel);
            vm.filter.selectedDetailLevel = selectedFn(vm.filter.detailLevel);
            vm.collasibleFilters = [];
            if (!_.isEmpty(vm.filter.region)) {
              vm.collasibleFilters.push({
                filter: 'region', isCollapsed: true,
                template: "StandardReports/Filters/RegionDimension.tmpl.html"
              });
            }
            if (!_.isEmpty(vm.filter.deviceType)) {
              vm.collasibleFilters.push({
                filter: 'deviceType', isCollapsed: true,
                template: "StandardReports/Filters/DeviceDimension.tmpl.html"
              });
            }

            vm.selectedHierarchy = Filters.getHierarchy();
            vm.collasibleFilters.push({
              filter: 'hierarchy', isCollapsed: true,
              template: "StandardReports/Filters/HierarchyDimension.tmpl.html"
            });

            _.each(vm.filter.deviceType, function (deviceType) { setParentIsSelected(deviceType); });
            _.each(vm.filter.region, function (region) { setParentIsSelected(region); });
          }

          function childElements(selectedObj) {
            return _.reduce(selectedObj.values, function (acc, obj) {
              acc.push(obj);
              if(obj.values && obj.values.length) {
                var child = childElements(obj);
                acc = acc.concat(child);
              }
              return acc;
            }, [])
          }

          function setParentIsSelected(parent) {
            if(parent.values && parent.values.length) {
              _.forEach(parent.values, setParentIsSelected);
              parent.isSelected = _.some(parent.values, {isSelected: true});
              parent.indeterminate = parent.isSelected && _.some(parent.values, function (region) {
                    return !region.isSelected || region.indeterminate
                  });
            }
          }

        }
      });
      return modalInstance;
    }

  }

  function Filter() {
    return {
      restrict: 'E',
      scope : true,
      templateUrl : 'StandardReports/Filters/Filter.tmpl.html',
      controller : 'StandardReportsFilterCtrl as vm',
      bindToController: true
    };
  }

  //@ngInject
  function StandardReportsFilterCtrl(FilterModal){
    var vm = this;

    var modalInstance;
    var opened = false;

    vm.openModal = function() {
      if (!opened){
        modalInstance = FilterModal.showModal();
      } else {
        modalInstance && modalInstance.close();
      }
      modalInstance.opened.then(function () { opened = true; });
      modalInstance.closed.then(function () { opened = false; });
    };

  }
})();